<div class="container paddingtop">
  <div style="margin-bottom: 20px;">
    <div>
      <span class="popupHeading"><b>{{'Notes' | translateOrgSpecific}}</b></span>
      <a (click)="onClose()"><i class="fas fa-times closebtn"></i></a>
    </div>
  </div>
  <div class="popup container">
    <div class="row form-group">   

      <div class="col-md-3 form-group"> {{'SelectCase' | translateOrgSpecific}}</div>
      <div class="col-md-9 form-group">
        <ejs-dropdownlist [dataSource]='caseList' [(ngModel)]="caseId"
        [fields]="{ text: 'issueCategoryName', value: 'case_id' }" [placeholder]="'Select Case'"
        ></ejs-dropdownlist>
      </div>
    </div>
    <div class="row form-group">
      
      <div class="col-md-3">
        <label>{{'Notes' | translateOrgSpecific}}</label>
      </div>
      <div class="col-md-9">


        <div class="row">
          <div class="col">
            <textarea class="form-control" rows="2" [(ngModel)]="notes" ></textarea>
          </div>
        </div>
        <div class="row" style="font-size: 14px;padding-top: 0.25rem;padding-bottom: 0.7rem">
          <div class="col-md-12" style="text-align: end; padding-top: 5px;">
            <button (click)=saveNotes() class="btn btn-sm btn-apportis-tertiary" [disabled]="!caseId || !notes">{{'Save' | translateOrgSpecific}}

            </button>
          </div>
        </div>
    </div>

    </div>

    <div >
      <table class="table table-striped table-sm" >
        <thead>
          <tr>
            <th scope="col">{{'Case' | translateOrgSpecific}} </th>
            <th scope="col">{{'Notes' | translateOrgSpecific}}</th>
            <th scope="col">{{'Action' | translateOrgSpecific}}</th>

          </tr>
        </thead>
        <tbody *ngIf="list_availabel">
          <tr *ngFor="let notlst of noteList; let i = index">

            <td>{{notlst.issuCgy}}</td>
            <td>  <ng-template #notestoolTip>
              <div> {{notlst.noteText }}</div>
             </ng-template>

            <div   
               *ngIf="20 > notlst.noteText.length   ">


              {{notlst.noteText }} 
            </div>
            <div *ngIf="notlst.noteText.length > 19"   class="cut-text"
            [ngbTooltip]="notestoolTip">


            {{notlst.noteText }} 
          </div>
          
          </td>
            <td>
              <a  title="Edit" class="grid-link mr-2">
                <span class="grid-icon"><i class="fas fa-calendar-check 7x" aria-hidden="true"
                  (click)="editNote(notlst)"  ></i></span>
            </a>
            </td>
         
          </tr>
        </tbody>
        <tbody *ngIf="!list_availabel">
          <div> {{'NoNotesAvailable' | translateOrgSpecific}} </div>
        </tbody>
      </table>

    </div>

  </div>



</div>










